import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const scrollToPosition = () => {
      if (hash) {
        const id = hash.replace("#", "");
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
          // スムーススクロール完了後に再計算（遅延）
          setTimeout(() => ScrollTrigger.refresh(), 150);
          return;
        }
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
      setTimeout(() => ScrollTrigger.refresh(), 150);
    };

    // 即実行（ページ遷移時）
    scrollToPosition();
  }, [pathname, hash]);

  return null;
}